import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-14 sm:px-6 sm:py-20" data-id="element-231" data-mp="3mgsks6m6b79w">
      <div className="mx-auto max-w-4xl" data-id="element-232" data-mp="3mfhdhwtirhe1">
        <h2 className="text-center font-display text-[1.75rem] font-bold leading-tight text-[#0E3B42] sm:text-[2.4rem]" data-id="element-233" data-mp="3r80ul3rf0unl">
          Cosa stanno già dicendo altri medici
        </h2>
        <div className="mt-4 flex flex-col items-center gap-1.5" data-id="element-234" data-mp="42t0t5qe0hlv">
          <span className="flex" aria-hidden="true" data-id="element-235" data-mp="40zujrjorzee">
            {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-[#D79B2B] text-[#D79B2B]" data-id="element-236" data-mp="92p6rainaj42" />)}
          </span>
          <p className="text-[13px] font-bold uppercase tracking-[0.1em] text-[#4A6B70]" data-id="element-237" data-mp="2au2b9ygpaozl">
            4.9/5 basato su oltre 1.200 medici
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5" data-id="element-238" data-mp="2fu6ptiy1t9n6">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-2xl border border-[#0E3B42]/10 bg-[#FBF8F3] p-5 sm:p-6" data-id="element-239" data-mp="1ntaubf0hbc79">
              <blockquote className="text-[14.5px] leading-relaxed text-[#3F5F64]" data-id="element-240" data-mp="1isdbd07nae4p">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-241" data-mp="2bic7tgo65dje">
                <img src={testimonial.photo} alt={`Ritratto di ${testimonial.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-white" width={96} height={96} loading="lazy" data-id="element-242" data-mp="26kk5rttt8b1h" />
                <div className="min-w-0" data-id="element-243" data-mp="r4lavk97ebj6">
                  <p className="text-[14px] font-bold leading-tight text-[#0E3B42]" data-id="element-244" data-mp="r1h0g555ajk2">
                    {testimonial.name}
                  </p>
                  <p className="mt-0.5 text-[12.5px] leading-snug text-[#4A6B70]" data-id="element-245" data-mp="nlcqg5lfa6ff">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>

        <CTAButton className="mt-10" label="Voglio unirmi agli oltre 1.200 medici" subline="Accesso immediato dopo il pagamento" data-id="element-246" data-mp="ek6abxmoqxmp" />
      </div>
    </section>;
}